module.exports = __webpack_public_path__ + "static/img/logo.5cb19da.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.png
// module id = BvKS
// module chunks = 1